// extracted by mini-css-extract-plugin
export default {"container":"spinnerDiv_container__Vha8G"};